module.exports = __webpack_public_path__ + "img/czleader7.c74cb169.png";